// @flow
import React from 'react';

import { NegativeMessageContainer } from '../presentational/messages/NegativeMessageContainer';
import { useIsEstimateRenewal } from '../../custom-hooks/useIsEstimateRenewal';
import { If } from '../presentational/If';

export const RenewalPolicyMessageContainer = () => {
  const renewalPolicyMessage =
    'Renewals must start with previous discounts and only increase/add discounts or credits if there is 20% growth over consumption ARR (shown in C360) per policy. Deal Strategy and TVP approval required for less than 20% growth. Renewal automation to come by EOQ.';
  const isRenewal = useIsEstimateRenewal();

  return (
    <If test={isRenewal}>
      <NegativeMessageContainer compact={true} header={renewalPolicyMessage} />
    </If>
  );
};
